import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isCollapse: false,
    userLevel: null,
    token: null,
    identity: null,
    tagList: [
      {
        icon: "el-icon-menu",
        title: "首页",
        path: "/home/admin-home"
      },
    ],
  },
  mutations: {
    // 用户等级保存到本地存储
    setUserLevel(state, level) {
      state.userLevel = level;
      localStorage.setItem('userLevel', level); 
    },
    // 身份保存到本地存储
    setToken(state, token) {
      state.token = token;
      localStorage.setItem('token', token); 
    },
    // 编号保存到本地存储
    setIdentity(state, identity) {
      state.identity = identity;
      localStorage.setItem('identity', identity); 
    },
    // 注销
    logout(state) {
      state.userLevel = null;
      state.token = null;
      state.identity = null;
      localStorage.removeItem('userLevel');
      localStorage.removeItem('token');
      localStorage.removeItem('identity');
    },  
    clickCollapse(state) {
      state.isCollapse = !state.isCollapse;
    },
    clickMenu(state, tag) {
      if (tag.title !== '首页') {
        const result = state.tagList.findIndex(item => item.title === tag.title);
        if (result === -1) {
          state.tagList.push(tag);
        }
      }
    },
    closeTag(state, tag) {
      const result = state.tagList.findIndex(item => item.title === tag.title);
      if (result !== -1) {
        state.tagList.splice(result, 1);
        console.log('tagList after mutation:', state.tagList); // 确认 mutation 后的状态
      }
    },
  },

});
